import type { RouteObject } from 'react-router';

import { clientLoader } from './client-loader';
import { dashboardRoutes } from './dashboard';
import { transactionsRoutes } from './transactions';
import { driversRoutes } from './drivers';
import { cardsRoutes } from './cards';
import { contractsRoutes } from './contracts';
import { couponsRoutes } from './coupons';
import { ordersRoutes } from './orders';
import { usersRoutes } from './users';
import { documentsRoutes } from './documents';
import { reportsRoutes } from './reports';

export const clientRoutes: RouteObject = {
  loader: clientLoader,
  children: [
    dashboardRoutes,
    transactionsRoutes,
    driversRoutes,
    cardsRoutes,
    contractsRoutes,
    couponsRoutes,
    ordersRoutes,
    usersRoutes,
    documentsRoutes,
    reportsRoutes,
  ],
};
